import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/Large-screens/7.png"


const corevalues = () => {
  return (
    <>
     <>
      <div className="home-container">
        <Sidebar />
        <div className="home-content">
          <img src={image} alt="example" className="home-image" />
        </div>
      </div>
    </>
    </>
  )
}

export default corevalues